export default "__VITE_ASSET__B7m09Xgv__"